import ModalWrapper from '@Components/Modals/ModalWrapper/ModalWrapper';
import LocationServices from '@Services/Location.services.ts';
import { Location } from '@Types/Asset.types';
import { handleRequestError } from '@Utils/request.utils';
import { ErrorDisplay, Toast } from '@kg-internal/pv3-uikit';
import { useState } from 'react';

type Props = {
  show: boolean;
  onClose: () => void;
  onSuccess: () => void;
  location?: Location;
};

const DeleteLocationModal = ({ show, onClose, onSuccess, location }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  const handleDeleteLocation = () => {
    LocationServices.disableLocation(location?.id)
      .then(() => {
        Toast.success('Location deleted successfully.');
        onSuccess();
        onClose();
      })
      .catch((error) => handleRequestError(error, setErrorMessage, true));
  };

  return (
    <div className='modal--fit-content modal--w-30vw modal--pt-20vh'>
      <ModalWrapper
        title='Delete Location'
        show={show}
        handleClose={onClose}
        primaryButtonText='Confirm'
        primaryAction={handleDeleteLocation}>
        {errorMessage ? (
          <ErrorDisplay inline details={errorMessage} />
        ) : (
          <div className='grid'>
            <div className='col-12'>
              <p>
                <b>Name</b> : {location?.name}
              </p>
              <p>
                <b>Location</b> : {location?.location}
              </p>
              <p>
                <b>Country</b> : {location?.country}
              </p>
              {location?.description && (
                <p>
                  <b>Details</b> : {location?.description}
                </p>
              )}
            </div>
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default DeleteLocationModal;
